import { Row } from "reactstrap";
import { Exitbtn } from "../../components/buttons/exitbtn";
import {
  AccountType,
  exerciseType,
} from "../../components/constants/constants";
import { Sendtaskbtn } from "../../components/buttons/sendTask";
import CheckButton from "../../components/buttons/CheckButton";

export const AdminBottomButtonPannel = ({
  show_send_task_button,
  isReview,
  getStudentid,
  student_level,
  exercise_page_no,
  exercise_id,
  book_id,
  ex_b_c,
  baseUrl,
  data,
  exercise_page_number,
  show_exercises,
  search,
  st_c_t_c,
  st_th_c,
  st_gr_c,
  st_fn_c,
  st_le_c,
  isSubmitting,
  get_tab,
  homework_tab_query_string,
  content_type,
  redirect,
  book_section_id,
  book_chapter_id
}) => {
  let href = null;
  let showExitButton = false;
  let query_string;
  if (redirect === "grading") {
    href = `${baseUrl}/school/school-quiz-grading/${getStudentid}?level=${student_level}&e-p-n=${exercise_page_no}`;
    showExitButton = true;
  } else if (redirect === "book") {
    query_string = `section-id=${book_section_id}&chapter-id=${book_chapter_id}`
    href = `${baseUrl}/school/book/${book_id}?${query_string}`;
    showExitButton = true;
  } else if (redirect === "exercises") {
    query_string = `e-p-n=${exercise_page_number}&s-e=${show_exercises}&reset=false`
    if(search){
      query_string = `${query_string}&search=${search}`;
    }
    if(st_c_t_c){
      query_string = `${query_string}&st_c_t_c=${st_c_t_c}`;
    }
    if(st_le_c){
      query_string = `${query_string}&st_le_c=${st_le_c}`;
    }
    if(ex_b_c){
      query_string = `${query_string}&ex_b_c=${ex_b_c}`;
    }
    if(st_th_c){
      query_string = `${query_string}&st_th_c=${st_th_c}`;
    }
    if(st_fn_c){
      query_string = `${query_string}&st_fn_c=${st_fn_c}`;
    }
    if(st_gr_c){
      query_string = `${query_string}&st_gr_c=${st_gr_c}`;
    }
    if(content_type){
      query_string = `${query_string}&type=${content_type}`;
    }
    href = `${baseUrl}/school/exercises?${query_string}`;
    showExitButton = true;
  } else if (redirect === "home") {
    href = `${baseUrl}/school/home`;
    showExitButton = true;
  } else if (redirect === "school_assignments") {
    if (get_tab) {
      href = `${baseUrl}/school/${get_tab}?${homework_tab_query_string}`;
      showExitButton = true;
    }
  }

  return (
    <Row>
      <div className="col-4 ">
        {showExitButton ? (
          <Exitbtn href={href} />
        ) : (
          <button  type="button"
          class="btn btn-md exit-btn-with"
          style={{ backgroundColor: "#ee3b3b", color: "white", width: "100px" }}  
          onClick={() => {
            window.history.go(-1);
          }}>
            <svg className="me-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 2V1H1V2H2ZM7.95956 9.37377C8.35008 9.7643 8.98325 9.7643 9.37377 9.37377C9.7643 8.98325 9.7643 8.35008 9.37377 7.95956L7.95956 9.37377ZM3 7.33333V2H1V7.33333H3ZM2 3H7.33333V1H2V3ZM1.29289 2.70711L7.95956 9.37377L9.37377 7.95956L2.70711 1.29289L1.29289 2.70711Z" fill="white"/>
              <path d="M2.66602 10.0003V10.0003C2.66602 10.3099 2.66602 10.4646 2.67743 10.5951C2.80432 12.0455 3.95421 13.1954 5.40455 13.3222C5.53503 13.3337 5.68981 13.3337 5.99935 13.3337H7.99935C10.1855 13.3337 11.2786 13.3337 12.0534 12.7911C12.3401 12.5904 12.5894 12.3411 12.7901 12.0544C13.3327 11.2796 13.3327 10.1865 13.3327 8.00033V6.00033C13.3327 5.69078 13.3327 5.53601 13.3213 5.40552C13.1944 3.95518 12.0445 2.8053 10.5942 2.67841C10.4637 2.66699 10.3089 2.66699 9.99935 2.66699V2.66699" stroke="white" stroke-width="2" stroke-linecap="round"/>
            </svg>
            Exit
          </button>
          // <input
          //   type="button"
          //   class="btn btn-md exit-btn-with"
          //   style={{ backgroundColor: "#ee3b3b", color: "white", width: "100px" }}
           
          //   value="Exit"
          //   action="action"
          // />
        )}
      </div>
      <div className="col-8 d-inline-flex  d-flex justify-content-end">
        {!isReview &&
        data.task_type !== exerciseType.WRITING_TASK &&
        data.task_type !== exerciseType.PRONUNCIATION_TASK &&
        data.user_type !== AccountType.STAFF &&
        show_send_task_button ? (
          <CheckButton isSubmitting={isSubmitting} />
        ) : null}
        {!isReview &&
        data.user_type !== AccountType.STAFF &&
        show_send_task_button ? (
          <div className="ms-2">
            {redirect === "home" ?(
              <Sendtaskbtn
              href={`${baseUrl}/school/home?exercise_id=${data.id}`}
            />
            ):(
            <Sendtaskbtn
              href={
                book_id
                  ? `${baseUrl}/school/book/${book_id}?${query_string}&exercise_id=${data.id}`
                  : `${baseUrl}/school/exercises?${query_string}&exercise_id=${data.id}`
              }
            />
            )}
          </div>
        ) : null}
      </div>
    </Row>
  );
};
